import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-prev.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-next.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-55c97fe2")

_pushScopeId("data-v-55c97fe2")
const _hoisted_1 = {
  key: 0,
  class: "text-14px self-center"
}
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "flex flex-row gap-x-4 text-14px items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  class: "h-4 mx-auto"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "",
  class: "h-4 mx-auto"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: 
      `flex flex-row space-x-4 ${_ctx.paginationPaddingVertical} bottom-0 z-10 right-0 my-4 ${_ctx.paginationWidth} ${
        _ctx.isShowCaption ? 'justify-between' : 'justify-end'
      } bg-white`
    
  }, [
    (_ctx.isShowCaption)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.showingLabel || _ctx.$t("showingPagination")) + " ", 1),
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.firstNumberOfPage), 1),
          _hoisted_3,
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.lastNumberOfPage), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.dataLabel), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_5, [
      (_ctx.pagination.page > 1)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: "focus:outline-none",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previousPage && _ctx.previousPage(...args)))
          }, [
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availablePage, (page) => {
        return (_openBlock(), _createBlock("button", {
          key: page,
          class: ["focus:outline-none font-medium", `${_ctx.pagination.page === page && 'page-active'}`],
          onClick: ($event: any) => (_ctx.setPage(page))
        }, _toDisplayString(page), 11, ["onClick"]))
      }), 128)),
      (_ctx.isNextPageAvailable)
        ? (_openBlock(), _createBlock("button", {
            key: 1,
            class: "focus:outline-none",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
          }, [
            _hoisted_7
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
})